(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    if (document.querySelector('.announcement-bar-section')) {
      this.announce = document.querySelector('.announcement-bar-section');
      this.setAnnounceHeight();
    } 
    else {
      this.withoutAnnounceHeight();
    }
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  setAnnounceHeight() {
    document.documentElement.style.setProperty('--announce-height', `${this.announce.offsetHeight}px`);
  }
  withoutAnnounceHeight() {
    document.documentElement.style.setProperty('--announce-height', `0px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    // this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

// document.addEventListener('DOMContentLoaded', function() {
//       var form = document.querySelector('.search__input');
//       var defaultSearch = document.querySelector('.default--search');

//       if (form && defaultSearch) {
//           form.addEventListener('focusin', function() {
//               defaultSearch.classList.add('focused');
//           });

//           form.addEventListener('focusout', function() {
//               defaultSearch.classList.remove('focused');
//           });
//       }
//   });
// document.addEventListener('DOMContentLoaded', function() {
//     var form = document.querySelector('.search__input');
//     var defaultSearch = document.querySelector('.default--search');

//     if (form && defaultSearch) {
//         // Add 'focused' class on focus
//         form.addEventListener('focusin', function() {
//             defaultSearch.classList.add('focused');
//         });

//         // Remove 'focused' class on blur
//         form.addEventListener('focusout', function() {
//             defaultSearch.classList.remove('focused');
//         });

//         // Remove 'focused' class on keydown
//         form.addEventListener('keydown', function() {
//             defaultSearch.classList.remove('focused');
//         });
//     }
// });
// document.addEventListener('DOMContentLoaded', function() {
//     var form = document.querySelector('.search__input');
//     var defaultSearch = document.querySelector('.default--search');
//     var focusHandled = false; // Flag to track if focus events should be handled

//     if (form && defaultSearch) {
//         // Add 'focused' class on focus
//         form.addEventListener('focusin', function() {
//             if (!focusHandled) {
//                 defaultSearch.classList.add('focused');
//             }
//         });

//         // Remove 'focused' class on blur
//         form.addEventListener('focusout', function() {
//             if (!focusHandled) {
//                 defaultSearch.classList.remove('focused');
//             }
//         });

//         // Remove 'focused' class on keydown and stop further focus handling
//         form.addEventListener('keydown', function() {
//             if (!focusHandled) {
//                 defaultSearch.classList.remove('focused');
//                 focusHandled = true; // Stop handling focus events
//             }
//         });
        
//         // Optional: Reset focus handling if input is cleared (if needed)
//         form.addEventListener('input', function() {
//             if (form.value === '') {
//                 focusHandled = false; // Re-enable focus handling if input is empty
//                 defaultSearch.classList.remove('focused');
//             }
//         });
//     }
// });
// document.addEventListener('DOMContentLoaded', function() {
//     var form = document.querySelector('.search__input');
//     var defaultSearch = document.querySelector('.default--search');
//     var classRemoved = false; // Flag to track if the class has been removed

//     if (form && defaultSearch) {
//         // Function to update the class based on input value
//         function updateFocusClass() {
//             if (form.value.length > 0) {
//                 defaultSearch.classList.remove('focused');
//                 classRemoved = true; // Track that class has been removed
//             } else if (classRemoved) {
//                 defaultSearch.classList.add('focused');
//                 classRemoved = false; // Reset flag if class is re-added
//             }
//         }

//         // Add 'focused' class on focus
//         form.addEventListener('focusin', function() {
//             if (form.value.length === 0 && !classRemoved) {
//                 defaultSearch.classList.add('focused');
//             }
//         });

//         // Remove 'focused' class on blur if there are characters
//         form.addEventListener('focusout', function() {
//             if (form.value.length > 0) {
//                 defaultSearch.classList.remove('focused');
//                 classRemoved = true; // Track that class has been removed
//             }
//         });

//         // Handle keydown and input events
//         form.addEventListener('keydown', function() {
//             updateFocusClass();
//         });

//         form.addEventListener('input', function() {
//             updateFocusClass();
//         });
//     }
// });
// document.addEventListener('DOMContentLoaded', function() {
//     var form = document.querySelector('.search__input');
//     var defaultSearch = document.querySelector('.default--search');
//     var hasCharacters = false; // Flag to track if there are characters in the input field

//     if (form && defaultSearch) {
//         // Function to update the 'focused' class based on input value
//         function updateFocusClass() {
//             if (form.value.length > 0) {
//                 defaultSearch.classList.remove('focused');
//                 hasCharacters = true; // Indicate that there are characters in the input
//             } else if (hasCharacters) {
//                 defaultSearch.classList.add('focused');
//                 hasCharacters = false; // Reset flag if input is empty
//             }
//         }

//         // Add 'focused' class on focus if the input is empty
//         form.addEventListener('focusin', function() {
//             if (form.value.length === 0 && !hasCharacters) {
//                 defaultSearch.classList.add('focused');
//             }
//         });

//         // Remove 'focused' class on blur if there are characters
//         form.addEventListener('focusout', function() {
//             if (form.value.length > 0) {
//                 defaultSearch.classList.remove('focused');
//             }
//         });

//         // Handle keydown and input events to update the focus class dynamically
//         form.addEventListener('keydown', function() {
//             updateFocusClass();
//         });

//         form.addEventListener('input', function() {
//             updateFocusClass();
//         });
//     }
// });
document.addEventListener('DOMContentLoaded', function() {
  var form = document.querySelector('.search__input');
  var defaultSearch = document.querySelector('.default--search');
  var hasCharacters = false;

  if (form && defaultSearch) {
    function updateFocusClass() {
      if (form.value.length > 0) {
        defaultSearch.classList.add('hidden'); 
        hasCharacters = true;
      } else if (hasCharacters) {
        defaultSearch.classList.remove('hidden');
        hasCharacters = false;
      }
    }

    form.addEventListener('focusin', function() {
      if (form.value.length === 0 && !hasCharacters) {
        defaultSearch.classList.remove('hidden');
      }
    });

    form.addEventListener('focusout', function() {
      if (form.value.length > 0) {
        defaultSearch.classList.add('hidden');
      }
    });

    form.addEventListener('keydown', function() {
      updateFocusClass();
    });

    form.addEventListener('input', function() {
      updateFocusClass();
    });
    document.addEventListener('keydown', function(event) {
      if (event.key === "Escape") {
        form.blur();
        defaultSearch.classList.add('hidden');
      }
    });

    document.addEventListener('click', function(event) {
      if (!form.contains(event.target) && !defaultSearch.contains(event.target)) {
        defaultSearch.classList.add('hidden');
        form.blur(); 
      }
    });
  }
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbquickview"]) return;
  try {
    
            class ProductModal extends ModalDialog {
                constructor() {
                super();
                }

                hide() {
                super.hide();
                }

                show(opener) {
                super.show(opener);
                this.showActiveMedia();
                }

                showActiveMedia() {
                this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                    element.classList.remove('active');
                    }
                )
                const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
                const activeMediaTemplate = activeMedia.querySelector('template');
                const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
                activeMedia.classList.add('active');
                activeMedia.scrollIntoView();

                const container = this.querySelector('[role="document"]');
                container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

                if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
                    activeMedia.loadContent();
                }
            }

            customElements.define('product-modal', ProductModal);
            
  } catch(e) { console.error(e); }
})();
})();
